import { Data2, newId, dateToString } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { Currency } from '../../../tables/types/types'
import { PaymentStatus } from '../../operations'
import { useSystemStateHooks } from '../../system'
import { Expense } from '../state/types'

export const useExpenseBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildExpense = (data: Data2) => {
        const {
            id = newId(),
            code,
            name,
            expenseTypeId,
            date,
            branchId,
            amount,
            currency,
            detail,
            employeeId,
            supplierId,
            refundEmployeeId,
            paymentStatus,
            archived
        } = data
        const expense: Expense = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            name: name! as string,
            expenseTypeId: expenseTypeId! as string,
            date: dateToString(date || new Date())!,
            branchId: branchId! as string,
            amount: amount! as number,
            currency: currency! as Currency,
            detail: detail as O<string>,
            employeeId: employeeId! as string,
            supplierId: supplierId as O<string>,
            refundEmployeeId: refundEmployeeId as O<string>,
            paymentStatus: (paymentStatus || PaymentStatus.PENDING) as PaymentStatus,
            archived: !!archived
        }
        return expense
    }

    return {
        buildExpense
    }
}
